import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { primePreset } from '@/theme/primePreset'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import 'primeicons/primeicons.css';
import App from './App.vue'
import { registerDirectives } from './directives'
import { registerPlugins } from './plugins'
import './style.css'

const app = createApp(App)

app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: primePreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
      cssLayer: false,
    },
  },
})

registerDirectives(app)
registerPlugins(app)
app.mount('#app')